import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { RegionForm } from '../RegionForm';
import { useRegionStore } from '@/stores/regionStore';
import { useCreateRegion } from '@/hooks/useRegions';
import { CreateRegionInput } from '@/features/regions/types';

interface RegionCreateModalProps {
  providerId: number;
}

export function RegionCreateModal({ providerId }: RegionCreateModalProps) {
  const { isCreateModalOpen, closeCreateModal } = useRegionStore();
  const { mutate: createRegion, isPending: isLoading } = useCreateRegion();

  const handleSubmit = (data: CreateRegionInput) => {
    createRegion(data, {
      onSuccess: () => {
        closeCreateModal();
      }
    });
  };

  return (
    <Dialog open={isCreateModalOpen} onOpenChange={(open) => !open && closeCreateModal()}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Create Region</DialogTitle>
        </DialogHeader>
        <RegionForm
          providerId={providerId}
          onSubmit={handleSubmit}
          isSubmitting={isLoading}
        />
      </DialogContent>
    </Dialog>
  );
}
